import { render, staticRenderFns } from "./ConfirmationMessage.vue?vue&type=template&id=066d2e0c&scoped=true&"
import script from "./ConfirmationMessage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationMessage.vue?vue&type=style&index=0&id=066d2e0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066d2e0c",
  null
  
)

export default component.exports